import React from "react"
import {Card} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { injectIntl, Link } from "gatsby-plugin-react-intl";
import {graphql, StaticQuery} from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const ChannelIcon = props => (
    <StaticQuery
        query={graphql`
          query {
            images: allFile(
              filter: {
                childImageSharp: { 
                  internal: {
                    type: { eq: "ImageSharp" }
                  }
                }
              }
            ) {
              nodes {
                relativePath
                name
                childImageSharp {
                  gatsbyImageData(layout: FIXED, width: 100, height: 90, placeholder: NONE)
                }
              }
            }
          }
        `}
        render={data => {
            const image = data.images.nodes.find(node => {
                return node.relativePath.includes(props.filename);
            });
            if (!image) {
                return null;
            }
            return <GatsbyImage alt={props.alt} image={getImage(image)} />;
        }}
    />
);

const IconCard = ({ intl, content }) => (
    <div className={`icon-card`}>
        <Card>
            <Link className={`card-button`} to={content.button.url}>
                <Card.Body>
                    <div className={`card-icon`}><ChannelIcon alt={content.title} filename={content.icon} /></div>
                    <div className={`card-title-line`}></div>
                    <Card.Title>{content.title}</Card.Title>
                    <Card.Text>
                        <span dangerouslySetInnerHTML={{__html: content.text}}></span>
                    </Card.Text>
                    <div className={`button`}>
                        {content.button.label} <FontAwesomeIcon icon="arrow-right"/>
                    </div>
                </Card.Body>
            </Link>
        </Card>
    </div>
)

export default injectIntl(IconCard)
